import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.pam-immo.com/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token JWT
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Intercepteur pour gérer les erreurs
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('user');
      // Redirection vers login si on est sur une page backoffice
      if (window.location.pathname.startsWith('/backoffice')) {
        window.location.href = '/backoffice/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
